import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from "vue-gtag"

Vue.config.productionTip = false
Vue.prototype.hash = window.location.hash.substring(1)

// Google Analytics 
Vue.use(VueGtag, {
  config: { id: "UA-101221994-1" }
}, router);


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
